import { useNavigationItems } from '@src/hooks/useNavigationItems';
import { MobileModalProvider } from '@src/providers/MobileModalProvider';
import { ThemeProvider } from '@src/styles/ThemeProvider';
import { Stack, usePreferredTheme } from '@talos/kyoko';
import { Navigate, Route, Routes } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';
import { useThemeTypePreference } from '../../hooks/useThemeTypePreference';
import { MobileTradingRoute } from './Trading/MobileTradingRoute';

const MOBILE_PAGE_COMPONENTS = {
  '/trading': <MobileTradingRoute />,
  '/analytics': <div>Analytics</div>,
  '/dealer': <div>Dealer</div>,
  '/portfolio': <div>Portfolio</div>,
  '/portfolio-engineering': <div>Portfolio Engineering</div>,
  '/monitoring': <div>Monitoring</div>,
  '/admin': <div>Admin</div>,
  '/talos-admin': <div>Talos Admin</div>,
  '/settings': <div>Settings</div>,
};

export const MobileStyles = createGlobalStyle`
  html, body {
    // Make sure the background behind the address bar is the same as the background content on mobile
    background: ${({ theme }) => theme.backgroundContent};
  }
`;

function isMobilePagePath(path: string): path is keyof typeof MOBILE_PAGE_COMPONENTS {
  return path in MOBILE_PAGE_COMPONENTS;
}

function MobilePages() {
  const { navItems } = useNavigationItems();
  const { themeType } = useThemeTypePreference();
  const preferredTheme = usePreferredTheme('DarkTalosMobileTheme', themeType);

  return (
    <ThemeProvider theme={preferredTheme}>
      <MobileStyles />
      <MobileModalProvider>
        <Stack overflow="auto" h="100vh" background="backgroundContent">
          <Routes>
            <Route path="/" element={<Navigate to="/trading" replace />} />
            {navItems.map(item =>
              item.path && isMobilePagePath(item.path) ? (
                <Route key={item.path} path={`${item.path}/*`} element={MOBILE_PAGE_COMPONENTS[item.path]} />
              ) : null
            )}
          </Routes>
        </Stack>
      </MobileModalProvider>
    </ThemeProvider>
  );
}

export default MobilePages;
